import { useAuth } from "@/context/AuthContext";
import { LoadingState } from "@/components/common/States";
import SchoolLangganan from "./SchoolLangganan";
import SchoolLanggananSaya from "./SchoolLanggananSaya";

export default function LanggananPage() {
  const { me, loading } = useAuth();
  if (loading) return <div className="p-10"><LoadingState /></div>;
  if (!me) return null;
  const isAdmin = me.active_school?.role === "school_admin";
  return isAdmin ? <SchoolLangganan /> : <SchoolLanggananSaya />;
}
